import styled from 'styled-components'
import { containerWide } from 'app/sofia/resources/theme/css'

export const Container = styled.div<any>`
  background: ${props => props.theme.palette.general.light};
  border-bottom: ${props => props.isLivBrite ? 'none' : `1px solid ${(props: any) => props.theme.palette.general.soft}`};
  position: sticky;
  top: 0;
  z-index: 9;
  transition: all ease-in-out 0.3s;
  ${props => props.isLivBrite && `
    min-height: 110px;
  `}

  > div {
    &:first-child {
      ${containerWide}
      ${props => props.isLivBrite && `
        margin-bottom: 10px;
      `}
    }
  }
`

export const Logo = styled.div`
  display: block;
  display: flex;
  align-items: center;
  margin: 18px 0;
  width: 20%;

  a {
    display: block;
    width: 100%;
  }

  svg {
    display: block;
    max-width: 255px;
    width: 100%;
    height: 46px;
    fill: ${props => props.theme.palette.general.strong};
  }
`
export const AbsoluteLogo = styled.div`
  position: absolute;
  bottom: -10px;
  max-height: 100px;
  width: 175px;

  img {
    max-width: 100%;
  }
`

export const MainSection = styled.div`
  ${containerWide}
  display: flex;
  align-items: center;
  position: relative;
`
export const SmallMenuWrapper = styled.div`
  margin-left: auto;
  position: relative;
`
